import { z } from "zod";

import { validationUrlErrorMessages } from "../i18n/validation-error-codes.ts";

const domainLabelRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/;
const tldRegex = /^[a-zA-Z]{2,10}$/;

export const urlSchema = z
  .string()
  .max(2000, validationUrlErrorMessages.max.id)
  .refine(
    (value) => {
      return /^(https?:\/\/|www\.|)/i.test(value);
    },
    {
      message: validationUrlErrorMessages.invalidStart.id,
    },
  )
  .refine(
    (value) => {
      const normalized = value
        .replace(/^https?:\/\//i, "")
        .replace(/^www\./i, "");
      const domain = normalized.split("/")[0];
      const parts = domain.split(".");

      if (parts.length < 2) {
        return false;
      }

      const tld = parts.at(-1)!;
      if (!tldRegex.test(tld)) {
        return false;
      }

      const subdomains = parts.slice(0, -1);
      return subdomains.every(
        (label) =>
          label.length >= 1 &&
          label.length <= 63 &&
          domainLabelRegex.test(label),
      );
    },
    {
      message: validationUrlErrorMessages.invalidDomains.id,
    },
  );
